<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  // import  '../static/font.css'
  // import  '../static/fontc.css'
  // import  '../static/fontr.css'
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: 'Avenir',  Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #F5F7FB;

}
  /*#app img[src]{*/
  /*  opacity: 0;*/
  /*}*/
  .head_a{
    position: relative;
  }
  .pll{
    position: absolute;
    top: 0rem;
    font-size: 1.5rem;
    left: 1rem;
  }
      @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
      .rule-box{
            padding-top:30px !important;
        }
        .pll{
           top: 30px !important;
        }
    }
    @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:3) {
      .rule-box{
            padding-top:30px !important;
        }
         .pll{
           top: 30px !important;
        }
    }
    @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:2) {
      .rule-box{
            padding-top:30px !important;
        }
         .pll{
           top: 30px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue